import React from "react";
import { Navigate } from "react-router-dom";
import { Center, Spinner } from "@chakra-ui/react";
import { useAuth } from "../contexts/AuthContext";
import { isPartnerRole } from "../services/authService";

export function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, authLoading, claims, claimsLoading } = useAuth();

  if (authLoading || claimsLoading) {
    return (
      <Center minH="100vh">
        <Spinner size="xl" color="brand.500" thickness="4px" />
      </Center>
    );
  }

  if (!user || !isPartnerRole(claims)) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return <>{children}</>;
}
